import Vue from 'vue';

// Create a new Vue instance to use as EventBus
const EventBus = new Vue();

export default EventBus;


